/* Sivana theme script
   - Scroll fade-ins
   - Manual product slideshow
   - Bundle pricing by number of items (1 = full price, 2 = 2-item %, 3+ = 3+ item %)
   - Color picker: each item in a bundle can be a different variant
   - Shopify AJAX cart drawer (prices and discounts come from Shopify)
   - Re-initialises sections when they change in the theme editor */
(function () {
  'use strict';
  const T = window.FirmoraTheme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, currency: 'USD', locale: 'en', freeShippingThreshold: 5000, maxJars: 10 };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = document.body.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);

  let fmt;
  try { fmt = new Intl.NumberFormat(T.locale, { style: 'currency', currency: T.currency || 'USD' }); }
  catch (e) { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
  const money = cents => fmt.format((cents || 0) / 100);

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#toast'); if (!el) return;
    el.textContent = msg; el.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('show'), 3600);
  }

  /* ---------- Scroll reveal ---------- */
  let io = null;
  function initReveal(root) {
    if (designMode || reduce || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('reveal-on');
    if (!io) {
      io = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    $$('.reveal:not(.in)', root).forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) requestAnimationFrame(() => el.classList.add('in'));
      else io.observe(el);
    });
  }

  /* ---------- Header shadow ---------- */
  function onScroll() { const h = $('#header'); if (h) h.classList.toggle('scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Product section ---------- */
  function initProduct(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    let cfg = {};
    try { cfg = JSON.parse($('[data-product-config]', root).textContent); } catch (e) {}
    const PRICE = cfg.price || 0;
    const MAX = cfg.maxJars || T.maxJars || 10;

    /* Slideshow */
    const track = $('[data-track]', root), stage = $('[data-stage]', root), counter = $('[data-counter]', root);
    const thumbs = $$('[data-thumb]', root);
    const total = $$('.slide', root).length;
    let idx = 0;
    function go(i) {
      if (!total) return;
      idx = (i + total) % total;
      track.style.transform = `translateX(${-idx * 100}%)`;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === idx ? 'true' : 'false'));
      if (counter) counter.textContent = `${idx + 1} / ${total}`;
    }
    thumbs.forEach((t, n) => t.addEventListener('click', () => go(n)));
    $$('[data-step]', root).forEach(b => b.addEventListener('click', () => go(idx + Number(b.dataset.step))));
    if (stage) {
      stage.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      });
      let startX = null, dx = 0, w = 1;
      stage.addEventListener('pointerdown', e => {
        if (e.target.closest('button')) return;
        startX = e.clientX; dx = 0; w = stage.offsetWidth; track.style.transition = 'none';
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      });
      stage.addEventListener('pointermove', e => {
        if (startX === null) return;
        dx = e.clientX - startX;
        track.style.transform = `translateX(calc(${-idx * 100}% + ${dx}px))`;
      });
      const end = () => {
        if (startX === null) return;
        track.style.transition = '';
        if (Math.abs(dx) > w * 0.15) go(idx + (dx < 0 ? 1 : -1)); else go(idx);
        startX = null;
      };
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
    }

    /* Variants: each item in a bundle can be a different variant (for example, a color) */
    const VARIANTS = (cfg.variants && cfg.variants.length) ? cfg.variants : [{ id: cfg.variantId, price: PRICE, available: cfg.available !== false, title: '' }];
    const vById = {};
    VARIANTS.forEach(v => { vById[String(v.id)] = v; });
    const firstAvail = String((VARIANTS.find(v => v.available) || VARIANTS[0]).id);
    const startId = vById[String(cfg.variantId)] && vById[String(cfg.variantId)].available ? String(cfg.variantId) : firstAvail;
    const picks = [startId];
    const priceOf = id => { const v = vById[String(id)]; return v ? v.price : PRICE; };
    const picksFor = n => { const out = picks.slice(0, n); while (out.length < n) out.push(out[out.length - 1] || startId); return out; };
    if (cfg.unitOne) T.unitOne = cfg.unitOne;
    if (cfg.unitMany) T.unitMany = cfg.unitMany;
    const one = T.unitOne || 'item';

    /* Bundle pricing by number of items */
    const pctFor = n => n >= 3 ? (cfg.trioPct || 0) : n === 2 ? (cfg.duoPct || 0) : 0;
    /* Same math as Shopify checkout: discount per item, rounded down to the cent. */
    const offPrice = (p, pct) => p - Math.floor(p * pct / 100);
    /* Regular price per item: the Compare-at price when it is higher than the price */
    const fullOf = id => { const v = vById[String(id)]; return v ? Math.max(v.compareAt || 0, v.price) : PRICE; };
    const fullFor = n => picksFor(n).reduce((sum, id) => sum + fullOf(id), 0);
    const listFor = n => picksFor(n).reduce((sum, id) => sum + priceOf(id), 0);
    const priceFor = n => { const pct = pctFor(n); return picksFor(n).reduce((sum, id) => sum + offPrice(priceOf(id), pct), 0); };
    /* Subscribe & Save (Shopify Subscriptions selling plans) */
    const pt = $('[data-purchase-type]', root);
    const planSelect = pt ? $('[data-selling-plan]', pt) : null;
    const plan = () => {
      if (!pt || !planSelect) return null;
      const on = $('input[value="subscribe"]', pt);
      if (!on || !on.checked) return null;
      const opt = planSelect.selectedOptions[0]; if (!opt) return null;
      return { id: planSelect.value, type: opt.dataset.type, value: Number(opt.dataset.value) || 0 };
    };
    const planUnit = (p, base) => p.type === 'percentage' ? Math.round(base * (100 - p.value) / 100)
      : p.type === 'fixed_amount' ? Math.max(0, base - p.value)
      : p.type === 'price' ? p.value : base;
    const stack = pt && pt.dataset.stack === '1';
    /* Subscription price per item: the plan price, then (if stacking) the bundle % off that, rounded down per item like checkout. */
    const subTotal = (p, n) => {
      const pct = stack ? pctFor(n) : 0;
      return picksFor(n).reduce((sum, id) => { const u = planUnit(p, priceOf(id)); return sum + u - Math.floor(u * pct / 100); }, 0);
    };

    /* Colors / sizes inside Bundle & Save: one dropdown per item, each opens a pop-up of options */
    const bcfg = $('[data-bcfg]', root);
    const rowsWrap = bcfg ? $('[data-vrows]', bcfg) : null;
    const rowTpl = rowsWrap ? rowsWrap.firstElementChild.cloneNode(true) : null;
    const pop = bcfg ? $('[data-dd-pop]', bcfg) : null;
    const unitLabel = bcfg ? (bcfg.dataset.unitLabel || 'Item') : 'Item';
    const optLabel = bcfg ? (bcfg.dataset.optionLabel || 'Option') : 'Option';
    const slides = $$('.slide', root);
    let openRow = -1;
    /* Show options from smallest to largest number in their name (15m, 20m, 30m, 50m). Names without a number keep their order. */
    if (pop) {
      const grid = $('.dd-grid', pop);
      const num = o => { const m = ($('.dd-name', o) || o).textContent.match(/\d+(\.\d+)?/); return m ? parseFloat(m[0]) : Infinity; };
      const opts = $$('.dd-opt', pop).map((o, i) => ({ o, i, n: num(o) }));
      if (grid && opts.some(x => x.n !== Infinity)) {
        opts.sort((a, b) => (a.n - b.n) || (a.i - b.i)).forEach(x => grid.appendChild(x.o));
      }
    }
    const optEl = id => pop ? $(`.dd-opt[data-variant-id="${id}"]`, pop) : null;
    const rowList = () => rowsWrap ? Array.from(rowsWrap.children).filter(c => c.hasAttribute('data-row')) : [];
    function renderRows(n) {
      if (!rowsWrap || !rowTpl) return;
      if (rowList().length !== n) closePop(false);
      while (rowList().length < n) rowsWrap.appendChild(rowTpl.cloneNode(true));
      while (rowList().length > n) rowList().pop().remove();
      const pct = pctFor(n);
      rowList().forEach((row, i) => {
        row.dataset.row = i;
        const cur = String(picks[i] || startId);
        const label = $('[data-vrow-label]', row); if (label) label.textContent = n > 1 ? `${unitLabel} ${i + 1}` : optLabel;
        const name = $('[data-dd-name]', row); if (name) name.textContent = (vById[cur] || {}).title || '';
        const pr = $('[data-dd-price]', row); if (pr) pr.textContent = money(offPrice(priceOf(cur), pct)) + (n > 1 ? ' each' : '');
        const thumb = $('[data-dd-thumb]', row), src = optEl(cur);
        if (thumb && src && thumb.dataset.for !== cur) { thumb.innerHTML = $('.dd-img', src).innerHTML; thumb.dataset.for = cur; }
        const dd = $('[data-dd]', row);
        if (dd) {
          dd.setAttribute('aria-expanded', openRow === i ? 'true' : 'false');
          dd.setAttribute('aria-label', `${label ? label.textContent : optLabel}: ${(vById[cur] || {}).title || ''}. Change`);
        }
      });
    }
    function closePop(focusBack) {
      if (!pop || pop.hidden) return;
      const row = rowList()[openRow];
      pop.hidden = true; openRow = -1;
      bcfg.appendChild(pop);
      $$('[data-dd]', rowsWrap).forEach(d => d.setAttribute('aria-expanded', 'false'));
      if (focusBack && row) { const dd = $('[data-dd]', row); if (dd) dd.focus(); }
    }
    function openPop(i) {
      if (!pop) return;
      const row = rowList()[i]; if (!row) return;
      const n = rowList().length, pct = pctFor(n), cur = String(picks[i] || startId);
      row.after(pop);
      openRow = i;
      const title = $('[data-dd-title]', pop);
      if (title) title.textContent = n > 1 ? `Choose ${optLabel.toLowerCase()} for ${unitLabel.toLowerCase()} ${i + 1}` : `Choose ${optLabel.toLowerCase()}`;
      $$('.dd-opt', pop).forEach(o => {
        o.setAttribute('aria-pressed', o.dataset.variantId === cur ? 'true' : 'false');
        const strong = $('[data-opt-price]', o), full = $('[data-opt-full]', o);
        const base = strong ? Number(strong.dataset.base) || priceOf(o.dataset.variantId) : 0;
        if (strong) strong.textContent = money(offPrice(base, pct)) + (n > 1 ? ' each' : '');
        const reg = Math.max(base, fullOf(o.dataset.variantId)), now = offPrice(base, pct);
        if (full) { full.textContent = money(reg); full.hidden = !(reg > now); }
      });
      const nPanel = $('[data-notify]', pop); if (nPanel) nPanel.hidden = true;
      pop.hidden = false;
      $$('[data-dd]', rowsWrap).forEach((d, k) => d.setAttribute('aria-expanded', k === i ? 'true' : 'false'));
      const sel = $('.dd-opt[aria-pressed="true"]', pop) || $('.dd-opt:not(:disabled)', pop);
      if (sel) sel.focus({ preventScroll: true });
    }
    /* Sold-out option: show the back-in-stock email signup for that option */
    function showNotify(o) {
      const panel = $('[data-notify]', pop); if (!panel) return;
      const title = (vById[o.dataset.variantId] || {}).title || '';
      const tags = $('[data-notify-tags]', panel); if (tags) tags.value = `back-in-stock, restock-${title}`;
      const head = $('[data-notify-title]', panel);
      if (head) { if (!head.dataset.base) head.dataset.base = head.textContent; head.textContent = title ? `${head.dataset.base}: ${title}` : head.dataset.base; }
      panel.hidden = false;
      const email = $('input[type="email"]', panel); if (email) email.focus({ preventScroll: true });
    }
    if (rowsWrap) rowsWrap.addEventListener('click', e => {
      const dd = e.target.closest('[data-dd]'); if (!dd) return;
      const i = Number(dd.closest('[data-row]').dataset.row) || 0;
      if (openRow === i) closePop(false); else openPop(i);
    });
    if (pop) {
      pop.addEventListener('click', e => {
        if (e.target.closest('[data-dd-close]')) { closePop(true); return; }
        const o = e.target.closest('.dd-opt'); if (!o || o.disabled) return;
        if (o.hasAttribute('data-soldout')) { showNotify(o); return; }
        const i = openRow;
        picks[i] = o.dataset.variantId;
        if (i === 0) for (let k = 1; k < picks.length; k++) if (!rowList()[k]) picks[k] = o.dataset.variantId;
        const media = o.dataset.mediaId;
        if (media) { const k = slides.findIndex(sl => sl.dataset.mediaId === media); if (k > -1) go(k); }
        closePop(true);
        refresh();
      });
      pop.addEventListener('keydown', e => { if (e.key === 'Escape') { e.stopPropagation(); closePop(true); } });
      document.addEventListener('click', e => { if (!pop.hidden && !pop.contains(e.target) && !e.target.closest('[data-dd]')) closePop(false); });
    }
    const cartItems = () => {
      const m = new Map();
      picksFor(qty()).forEach(id => m.set(String(id), (m.get(String(id)) || 0) + 1));
      return Array.from(m, ([id, quantity]) => ({ id, quantity }));
    };

    const qtyInput = $('[data-qty]', root);
    const qty = () => Math.min(MAX, Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1));

    function refresh() {
      const j = qty(), pct = pctFor(j), sp = plan();
      while (picks.length < j) picks.push(picks[picks.length - 1] || startId);
      if (openRow >= j) closePop(false);
      renderRows(j);
      const idInput = $('form[data-product-form] input[name="id"]', root); if (idInput) idInput.value = picks[0];
      const fsEl = $('[data-bundles]', root), shipMin = fsEl ? Number(fsEl.dataset.shipMin) || 0 : 0;
      const total = sp ? subTotal(sp, j) : priceFor(j), saved = fullFor(j) - total;
      if (pt) {
        $$('.pt-option, .pt-check', pt).forEach(o => o.classList.toggle('is-on', $('input', o).checked));
        const once = $('[data-pt-price-once]', pt); if (once) once.textContent = money(priceFor(j));
        const firstPlan = planSelect && planSelect.selectedOptions[0] ? { type: planSelect.selectedOptions[0].dataset.type, value: Number(planSelect.selectedOptions[0].dataset.value) || 0 } : null;
        const sub = $('[data-pt-price-sub]', pt); if (sub && firstPlan) sub.innerHTML = money(subTotal(firstPlan, j)) + '<small>per delivery</small>';
      }
      const hidden = $('[data-selling-plan-input]', root); if (hidden) hidden.value = sp ? sp.id : '';
      $$('[data-bundles] .bundle', root).forEach(l => {
        const n = Number(l.dataset.jars);
        const on = j >= 3 ? n === 3 : n === j;
        l.classList.toggle('is-on', on);
        const input = $('input', l); if (input) input.checked = on;
        const tierTotal = priceFor(n), tierFull = fullFor(n);
        const tp = $('[data-tier-price]', l); if (tp) tp.textContent = money(tierTotal);
        const tf = $('[data-tier-full]', l); if (tf) { tf.textContent = money(tierFull); tf.hidden = !(tierFull > tierTotal); }
        const ts = $('[data-tier-ship]', l); if (ts) ts.hidden = !(shipMin > 0 && tierTotal >= shipMin);
        const pill = $('[data-tier-pill]', l);
        if (pill) {
          const save = tierFull > 0 ? Math.round((tierFull - tierTotal) * 100 / tierFull) : 0;
          pill.hidden = !(save > 0);
          if (!pill.dataset.label) pill.textContent = `Save ${save}%`;
        }
        l.classList.toggle('bundle--open', on && !!bcfg);
        if (on && bcfg && l.nextElementSibling !== bcfg) l.after(bcfg);
      });
      const priceEl = $('[data-price]', root);
      if (priceEl) priceEl.innerHTML = money(total) + (saved > 0 ? `<s>${money(fullFor(j))}</s>` : '');
      const addPrice = $('[data-add-price]', root);
      if (addPrice) addPrice.textContent = money(total);
      const note = $('[data-tier-note]', root);
      if (note && sp) {
        note.textContent = saved > 0 ? `Subscribe & Save applied: you save ${money(saved)} on every delivery.` : 'Delivered automatically. Pause, skip or cancel anytime.';
      } else if (note) {
        const duo = cfg.duoPct || 0;
        note.textContent =
          j === 1 ? (duo > 0 ? `Add a second ${one} and save ${duo}% automatically.` : '') :
          pct <= 0 ? '' :
          `${pct}% bundle discount applied: you save ${money(Math.max(0, listFor(j) - total))}${fullFor(j) > listFor(j) ? ' more' : ''}.`;
      }
    }

    const fs = $('[data-bundles]', root);
    if (fs) fs.addEventListener('change', e => {
      if (e.target.matches('input[type="radio"]') && qtyInput) { qtyInput.value = e.target.value; refresh(); }
    });
    const minus = $('[data-qty-minus]', root), plus = $('[data-qty-plus]', root);
    if (minus) minus.addEventListener('click', () => { qtyInput.value = Math.max(1, qty() - 1); refresh(); });
    if (plus) plus.addEventListener('click', () => { qtyInput.value = Math.min(MAX, qty() + 1); refresh(); });
    if (qtyInput) qtyInput.addEventListener('change', () => { qtyInput.value = qty(); refresh(); });
    if (pt) {
      pt.addEventListener('change', e => {
        if (e.target === planSelect) { const s = $('input[value="subscribe"]', pt); if (s) s.checked = true; }
        refresh();
      });
    }
    refresh();

    /* Add to cart: the bundle you pick SETS the cart (Duo = 2 jars in the cart, not 2 more).
       One request to Shopify, which returns the updated cart right away. */
    const form = $('form[data-product-form]', root);
    if (form) form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('[data-add]', root);
      if (btn) { btn.disabled = true; btn.style.opacity = '.75'; }
      try {
        const sp = plan();
        Cart.render(await Cart.setItems(cartItems(), sp ? sp.id : null, VARIANTS.map(v => v.id)));
        Cart.open();
        bumpBadge();
      } catch (err) {
        toast(err.message);
        Cart.refresh();
      } finally {
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      }
    });

    /* Buy Now: cart permalink goes straight to checkout with just this order */
    const buy = $('[data-buy-now]', root);
    if (buy) buy.addEventListener('click', async () => {
      const sp = plan();
      if (!sp) {
        window.location.href = `${T.routes.root.replace(/\/$/, '')}/cart/${cartItems().map(i => `${i.id}:${i.quantity}`).join(',')}`;
        return;
      }
      /* Subscriptions: put the subscription in the cart, then go straight to checkout */
      buy.disabled = true;
      try {
        await Cart.setItems(cartItems(), sp.id, VARIANTS.map(v => v.id));
        window.location.href = `${T.routes.root.replace(/\/$/, '')}/checkout`;
      } catch (err) { toast(err.message); buy.disabled = false; }
    });
  }

  /* ---------- Cart drawer ---------- */
  function bumpBadge() {
    const b = $('#badge'); if (!b) return;
    b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump');
  }
  const Cart = {
    lastFocus: null,
    pending: {},
    timers: {},
    seq: 0,
    open() {
      const drawer = $('#drawer'), scrim = $('#scrim'); if (!drawer) return;
      this.refresh();
      this.lastFocus = document.activeElement;
      scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('show'));
      drawer.inert = false; drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => { const c = $('#closeCart'); if (c) c.focus(); }, 60);
    },
    close() {
      const drawer = $('#drawer'), scrim = $('#scrim'); if (!drawer) return;
      drawer.classList.remove('open'); scrim.classList.remove('show');
      drawer.inert = true; document.body.style.overflow = '';
      setTimeout(() => { scrim.hidden = true; }, 350);
      if (this.lastFocus) this.lastFocus.focus();
    },
    async api(path, body) {
      const res = await fetch(path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
        cache: 'no-store'
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
      return data;
    },
    /* Make the cart hold exactly these items of this product (all its variants are replaced),
       as a one-time purchase or on a subscription plan. items: [{ id, quantity }] */
    async setItems(items, planId, productVariantIds) {
      const cart = await this.api(T.routes.cart + '.js');
      const ids = new Set((productVariantIds && productVariantIds.length ? productVariantIds : items.map(i => i.id)).map(String));
      const lines = (cart.items || []).filter(i => ids.has(String(i.variant_id)));
      const planOf = i => i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? String(i.selling_plan_allocation.selling_plan.id) : null;
      const want = planId ? String(planId) : null;
      if (items.length === 1 && lines.length === 1 && String(lines[0].variant_id) === String(items[0].id) && planOf(lines[0]) === want) {
        return this.api(T.routes.cart + '/update.js', { updates: { [lines[0].key]: items[0].quantity } });
      }
      if (lines.length) {
        const zero = {}; lines.forEach(l => { zero[l.key] = 0; });
        await this.api(T.routes.cart + '/update.js', { updates: zero });
      }
      await this.api(T.routes.cartAdd + '.js', { items: items.map(i => {
        const o = { id: Number(i.id), quantity: i.quantity };
        if (want) o.selling_plan = Number(want);
        return o;
      }) });
      return this.api(T.routes.cart + '.js');
    },
    setProduct(variantId, quantity, planId) { return this.setItems([{ id: variantId, quantity }], planId); },
    async refresh() {
      const mySeq = ++this.seq;
      try {
        const res = await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        const data = await res.json();
        if (mySeq === this.seq && !Object.keys(this.pending).length) this.render(data);
      } catch (e) {}
    },
    async change(key, quantity) {
      const mySeq = ++this.seq;
      try {
        const res = await fetch(T.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Could not update the cart.');
        if (mySeq === this.seq && !Object.keys(this.pending).length) this.render(data);
      } catch (err) {
        toast('Your cart changed. It has been refreshed.');
        this.refresh();
      }
    },
    /* Show the new quantity instantly, then send one update to Shopify once clicking stops. */
    queue(key, quantity) {
      this.pending[key] = quantity;
      const line = document.querySelector(`#lines .line[data-key="${key}"]`);
      if (line) {
        const n = $('.mini span', line); if (n) n.textContent = quantity;
        const meta = $('[data-jars]', line); if (meta) meta.textContent = `${quantity} ${unitWord(quantity)}`;
        $$('.right span, .right s', line).forEach(el => { el.style.opacity = '.4'; });
      }
      const sub = $('#subtotal'); if (sub) sub.style.opacity = '.4';
      const total = (this.items || []).reduce((sum, i) => sum + (i.key in this.pending ? this.pending[i.key] : i.quantity), 0);
      const badge = $('#badge'); if (badge) { badge.textContent = total; badge.classList.toggle('show', total > 0); }
      clearTimeout(this.timers[key]);
      this.timers[key] = setTimeout(() => {
        const q = this.pending[key];
        delete this.pending[key];
        this.change(key, q);
      }, quantity === 0 ? 0 : 350);
    },
    render(cart) {
      const count = cart.item_count || 0;
      const badge = $('#badge'), btn = $('#cartBtn');
      if (badge) { badge.textContent = count; badge.classList.toggle('show', count > 0); }
      if (btn) btn.setAttribute('aria-label', `Open cart, ${count} item${count === 1 ? '' : 's'}`);
      const lines = $('#lines'); if (!lines) return;
      lines.innerHTML = (cart.items || []).map(item => {
        const img = item.image ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=200" alt="" width="72" height="90" loading="lazy">` : '<span></span>';
        const discounts = (item.line_level_discount_allocations || []).map(d => `<div class="meta" style="color:var(--rose)">${escapeHtml(d.discount_application.title)}</div>`).join('');
        const variant = item.variant_title ? `<div class="meta">${escapeHtml(item.variant_title)}</div>` : '';
        const planName = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? `<div class="meta" style="color:var(--plum)">↻ ${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</div>` : '';
        return `<li class="line" data-key="${item.key}">
          ${img}
          <div><h3>${escapeHtml(item.product_title)}</h3>${variant}<div class="meta" data-jars>${item.quantity} ${unitWord(item.quantity)}</div>${planName}${discounts}
            <div class="mini"><button type="button" data-act="dec" aria-label="Remove one">−</button><span>${item.quantity}</span><button type="button" data-act="inc" aria-label="Add one">+</button></div></div>
          <div class="right">${item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>` : ''}<span>${money(item.final_line_price)}</span><button type="button" class="remove" data-act="rm">Remove</button></div>
        </li>`;
      }).join('');
      $('#empty').hidden = count > 0;
      $('#dFoot').hidden = count === 0;
      $('#subtotal').textContent = money(cart.total_price);
      $('#subtotal').style.opacity = '';
      const discRow = $('#discountRow');
      if (discRow) {
        discRow.hidden = !(cart.total_discount > 0);
        $('#discountAmt').textContent = '−' + money(cart.total_discount);
      }
      const threshold = T.freeShippingThreshold || 0, left = threshold - cart.total_price;
      const msg = $('#shipMsg'), bar = $('#shipBar');
      if (msg && threshold > 0) msg.textContent = count === 0 ? `Free shipping on orders over ${money(threshold)}`
        : left > 0 ? `You're ${money(left)} away from free shipping.` : 'You’ve unlocked free shipping.';
      if (bar && threshold > 0) bar.style.width = Math.min(100, cart.total_price / threshold * 100) + '%';
      this.items = cart.items || [];
    }
  };
  function unitWord(n) { return n === 1 ? (T.unitOne || 'item') : (T.unitMany || 'items'); }
  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  function initCart() {
    const btn = $('#cartBtn');
    if (btn && !btn.dataset.ready) { btn.dataset.ready = '1'; btn.addEventListener('click', () => Cart.open()); }
  }
  document.addEventListener('click', e => {
    if (e.target.closest('#closeCart') || e.target.closest('#scrim')) Cart.close();
    const act = e.target.closest('#lines button[data-act]');
    if (act) {
      const key = act.closest('.line').dataset.key;
      const item = (Cart.items || []).find(i => i.key === key); if (!item) return;
      const max = T.maxJars || 10;
      let q = key in Cart.pending ? Cart.pending[key] : item.quantity;
      if (act.dataset.act === 'inc') { if (q >= max) { toast(`You can order up to ${max} ${unitWord(max)} at a time.`); return; } q += 1; }
      if (act.dataset.act === 'dec') q = Math.max(0, q - 1);
      if (act.dataset.act === 'rm') q = 0;
      Cart.queue(key, q);
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && $('#drawer.open')) Cart.close(); });

  /* ---------- Boot ---------- */
  function init(root) {
    $$('[data-product-section]', root).forEach(initProduct);
    initReveal(root);
  }
  function boot() {
    initCart();
    init(document);
    onScroll();
    Cart.refresh();
    /* Back-in-stock signup sent (Shopify reloads the page with customer_posted=true) */
    if (/[?&]customer_posted=true/.test(window.location.search) && /^#notify-/.test(window.location.hash) && $('[data-notify]')) {
      setTimeout(() => toast('You’re on the list! We’ll email you as soon as it’s back in stock.'), 400);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Back button from checkout shows a saved copy of the page; reload the real cart so it is never out of date. */
  window.addEventListener('pageshow', e => { if (e.persisted) Cart.refresh(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') Cart.refresh(); });

  /* Theme editor: re-run when a section is added, changed or re-ordered */
  document.addEventListener('shopify:section:load', e => { init(e.target); initCart(); });
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest('[data-product-section]'); if (slide) initProduct(slide);
  });
})();
